
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { benefits } from '../../../mocks/products';

export default function Benefits() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="about" className="py-14 md:py-24 px-5 md:px-8 bg-white">
      <div ref={ref} className="max-w-7xl mx-auto">
        <div className={`text-center mb-10 md:mb-16 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-xs font-semibold mb-3 md:mb-4">
            왜 자연담은인가요?
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            <strong>자연에서 온 건강한 선택</strong>
          </h2>
          <p className="text-xs md:text-sm text-gray-500 max-w-lg mx-auto leading-relaxed px-2">
            엄격한 품질 관리와 유기농 인증을 통해 가장 안전하고 신선한 건강식품을 제공합니다
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((item, index) => (
            <div
              key={item.title}
              className={`group p-5 md:p-8 rounded-2xl bg-stone-50 hover:bg-emerald-600 transition-all duration-500 cursor-default hover-lift ${
                isVisible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <div className="w-11 h-11 md:w-14 md:h-14 rounded-xl bg-emerald-100 group-hover:bg-white/20 flex items-center justify-center mb-4 md:mb-6 transition-all duration-500">
                <i
                  className={`${item.icon} text-xl md:text-2xl text-emerald-600 group-hover:text-white transition-colors duration-500 w-5 h-5 md:w-6 md:h-6 flex items-center justify-center`}
                ></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-gray-900 group-hover:text-white mb-2 md:mb-3 transition-colors duration-500">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-500 group-hover:text-white/80 leading-relaxed transition-colors duration-500">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
